// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"ArtefactBlock_wrapper__1ZCQF"};